import React from "react";
import { Container, Link, Typography, Paper } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

// styles are a placeholder for now
const styles = theme => ({
  paper: {
    ...theme.paper,
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  mcLink: {
    ...theme.typography.mcLink,
    color: theme.palette.tertiary.main
  }
});

class Contests extends React.Component {
  constructor(props) {
    super();
    this.state = {
      contestsUrl: props.tenantConfig.ui.urls.contests
    };
  }

  render() {
    const { classes } = this.props;

    if (this.props.authProps.authState) {
      if (this.props.authProps.isAuthenticated && this.props.authProps.user) {
        let content = (
          <Container maxWidth="sm">
            <Paper className={classes.paper}>
              <Typography variant="h2" gutterBottom>
                Contests
              </Typography>
              <Typography variant="body1">
                Clicking the link will redirect you to the site&apos;s contest
                page.
              </Typography>
              <Link
                className={classes.mcLink}
                href={this.state.contestsUrl}
                target="_blank"
                rel="noreferrer"
              >
                Go to the Contests Page
              </Link>
            </Paper>
          </Container>
        );

        return <div className="box cta">{content}</div>;
      }
    } else {
      return <span className="tag is-primary">Loading ...</span>;
    }
  }
}

export default withStyles(styles, { withTheme: true })(Contests);
